
import { uniqueToken, GpsBaseURL } from "../api/DataApis";
import request from "./request";


export const placeOrderApi = async (userData) => {
    console.log("userData", userData);
    const orderApi = `${GpsBaseURL}/web/order/add`;
  
    try {
      // 🆕 Convert userData into JSON format
     
  
      let res = await request({
        url: orderApi,
        method: "POST",
        data: userData, // ✅ Use JSON data
        headers: {
          "Content-Type": "application/json", // ✅ Set header for JSON data
          Accept: "application/json",
        },
      });
  
      return res; // 👈 Return API response
    } catch (error) {
      console.error("Error in placing order:", error);
    }
  
    return null;
  };

  export const getOrderList = async () => {
   
    const OrderlistApi = `${GpsBaseURL}/web/order`;
  
      let res = await request({
        url: OrderlistApi,
        // url: 'posts',
        method: "GET",
      
        headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
  
      if (res && res?.data) {
        //const data = res.data.student;
        // console.log("res",res.students)
        return res?.data
      }
      return [];
  }

  export const getTrackingOrder = async ( user_order_id ) => {
   
    const OrderlistApi = `${GpsBaseURL}/web/order/tracking-shipment/${user_order_id}`;
  
      let res = await request({
        url: OrderlistApi,
        // url: 'posts',
        method: "GET",
      
        headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
  
      if (res && res?.data) {
        //const data = res.data.student;
        // console.log("res",res.students)
        return res?.data
      }
      return [];
  }
  
 